import { Title, Image, Space, Text, Tabs, Group } from "@mantine/core";
import { Directions, Map, Walk } from "tabler-icons-react";
import zoomedOutMap from '../Media/ZoomedOutMap.png'
import walkRoute from '../Media/WalkRoute2025.png'
import siteMap from '../Media/SiteMap3.png'
import { useViewportSize } from "@mantine/hooks";

function Maps(props) {

    const { height, width } = useViewportSize()

    return (
        <div>
            <Space h="sm"></Space>
            <Tabs>
                <Tabs.Tab label="Address, Parking & Directions" icon={<Directions size={14} />}>
                    <Space h="md"></Space>
                    <Title order={3}>
                        Centennial Park
                    </Title>
                    <Title order={5}>
                        Picnic Area 6 & 7
                    </Title>
                    <Space h="md"></Space>
                    <Text>
                        Parking Lot:
                    </Text>
                    <Space h="md"></Space>
                    <Group position="center">
                        <a target="_blank" href="https://www.google.com/maps/place/Centennial+Park+Parking,+150+Elmcrest+Rd,+Etobicoke,+ON+M9C+3S2/@43.649953,-79.590196,15z/data=!4m6!3m5!1s0x882b390023e48b13:0xc1b919358b540e50!8m2!3d43.6499534!4d-79.5901961!16s%2Fg%2F11fmndbt4s?hl=en&gl=CA&g_ep=Eg1tbF8yMDI1MDUxMl8wIJvbDyoASAJQAQ%3D%3D">
                            <Text>
                            150 Elmcrest Rd
                            </Text>
                            <Text>
                            Etobicoke, ON
                            </Text>
                            <Text>
                            M9C 3S2
                            </Text>
                        </a>
                    </Group>
                    
                    <Space h="md"></Space>
                    <Text>
                        Limited parking spots are available at 150 Elmcrest Rd.  Please follow the directions of volunteers when you arrive.  Carpooling is encouraged.
                    </Text>
                    <Space h="xl"></Space>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5331.450907999265!2d-79.59466618895252!3d43.649900817668005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b390023e48b13%3A0xc1b919358b540e50!2sCentennial%20Park%20Parking!5e0!3m2!1sen!2sca!4v1747281562674!5m2!1sen!2sca" width={Math.min(width - 75, 600)} height="450" style={{border: 0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                </Tabs.Tab>
                <Tabs.Tab label="Site Map" icon={<Map size={14} />}>
                    <Space h="md"></Space>
                    {/*<Text>
                        A map of the picnic area, washroom facility, and parking lots will be available soon.
                    </Text>
                    <Space h="xl"></Space>*/}
                    <Image src={siteMap} style={{margin: 'auto', maxWidth: '600px'}} ></Image>
                </Tabs.Tab>
                <Tabs.Tab label="Walk Route" icon={<Walk size={14} />}>
                    <Space h="md"></Space>
                    <Space h="md"></Space>
                    {/*<Text>
                        The finalized walk route will be available soon.
                    </Text>*/}
                    <Text>
                        The finalized walk route has been posted below.  With a distance of approximately 2.4 km, it will take between 25 to 35 minutes to complete, depending on the individual.
                    </Text>
                    <Space h="xl"></Space>
                    <Image src={walkRoute} style={{margin: 'auto', maxWidth: '600px'}} ></Image>
                </Tabs.Tab>
            </Tabs>
            <Space h="md"></Space>
        </div>
    )
}
export default Maps;